/**
 *  @class
 *  @function MegaMenuSidebar
 */
if (!customElements.get('mega-menu-sidebar')) {
  class MegaMenuSidebar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('.mega-menu-sidebar--button');
      this.content = this.querySelectorAll('.mega-menu-sidebar--content-inner');
      this.viewAlls = this.querySelectorAll('.mega-menu-sidebar--content-view-all');
      this.customerLi = this.querySelector('.mega-menu-sidebar-customer-li');
      this.customerBtn = this.querySelector('.mega-menu-sidebar-customer-btn');

      this.buttons.forEach((button, i) => {
        button.addEventListener('mouseover', (event) => {
          this.onHover(event, button, i);
        });
      });

      if (this.customerLi && this.customerBtn && this.customerBtn.getAttribute('data-target')) {
        this.customerLi.addEventListener('mouseover', () => {
          this.onCustomerHover();
        });
      }

      this.images = this.querySelectorAll('img');

      window.addEventListener('load', (event) => {
        this.images.forEach(function (image) {
          lazySizes.loader.unveil(image);
        });
      });
    }

    setActiveViewAll(target) {
      this.viewAlls.forEach((viewAll) => {
        viewAll.classList.toggle('active', viewAll.getAttribute('data-target') === target);
      });
    }

    onHover(event, button, i) {
      var target = button.getAttribute('data-target');
      this.content.forEach((content, index) => {
        if (content.classList.contains('mega-menu-sidebar--content-inner--flat')) {
          content.classList.add('active');
          return;
        }
        var contentTarget = content.getAttribute('data-target');
        if (contentTarget) {
          content.classList.toggle('active', contentTarget === target);
        } else {
          content.classList.toggle('active', i === index);
        }
      });
      this.buttons.forEach((this_button) => {
        this_button.classList.remove('active');
      });
      button.classList.add('active');
      if (this.customerLi) this.customerLi.classList.remove('active');
      this.setActiveViewAll(target);
    }

    onCustomerHover() {
      this.buttons.forEach((this_button) => {
        this_button.classList.remove('active');
      });
      this.content.forEach((content) => {
        content.classList.remove('active');
      });
      if (this.customerLi) this.customerLi.classList.add('active');
      var target = this.customerBtn && this.customerBtn.getAttribute('data-target');
      this.setActiveViewAll(target);
    }
  }
  customElements.define('mega-menu-sidebar', MegaMenuSidebar);
}
